<template>
	<v-hover v-slot="{ hover }" close-delay="200" open-delay="200">
		<td class="px-1 editable-cell">
			<v-menu v-model="showForm" :close-on-click="false" :close-on-content-click="false">
				<template v-slot:activator="{ on, attrs }">
					<p v-text="cellValue(column)"></p>
					<v-btn
						icon
						x-small
						v-show="hover"
						color="secondary"
						class="edit-btn"
						fab
						absolute
						v-bind="attrs"
						v-on="on"
						outlined
					>
						<v-icon>mdi-pencil</v-icon>
					</v-btn>
				</template>
				<v-list class="pa-2 pt-4 top-border">
					<v-form v-model="valid">
						<AssociationSelectDialog
							v-if="column.meta_association_name"
							:label="''"
							:value.sync="value_target"
							:association_value.sync="value"
							:column_id="column.id"
							:urlType="'ledger'"
							:type="`${column.meta_association_name}_type`"
							:id="`${column.meta_association_name}_id`"
						/>
						<v-select
							v-else-if="column.options.length"
							v-model="value"
							:items="column.options"
							item-text="name"
							item-value="id"
							dense
							outlined
						/>
						<v-text-field
							v-model="value"
							dense
							outlined
							v-else-if="column.column_type == 'string'"
						/>
						<v-textarea v-model="value" dense outlined v-else-if="column.column_type == 'text'" />
						<v-text-field
							v-model="value"
							dense
							outlined
							:rules="[rules.integer]"
							v-else-if="column.column_type == 'integer'"
						/>
						<v-text-field
							v-model="value"
							dense
							outlined
							:rules="[rules.floatWithNegative]"
							v-else-if="column.column_type == 'float'"
						/>
						<v-radio-group v-else-if="column.column_type == 'boolean'" v-model="value" row>
							<v-radio label="○" :value="true" class="mx-2" />
							<v-radio label="x" :value="false" class="mx-2" />
						</v-radio-group>
						<v-menu
							ref="menu"
							v-else-if="column.column_type == 'date'"
							close-on-content-click
							transition="scale-transition"
							offset-y
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-model="value"
									outlined
									dense
									readonly
									v-bind="attrs"
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker v-model="value" no-title scrollable locale="ja" />
						</v-menu>
						<template v-else-if="column.column_type == 'datetime'">
							<v-row no-gutters>
								<v-select
									v-model="datetime.year"
									:items="years"
									class="px-1 w100"
									label="年"
									dense
									outlined
								/>
								<v-select
									v-model="datetime.month"
									:items="months"
									class="px-1 w100"
									label="月"
									dense
									outlined
								/>
								<v-select
									v-model="datetime.day"
									:items="days"
									class="px-1 w100"
									label="日"
									dense
									outlined
								/>
							</v-row>
							<v-row no-gutters>
								<v-select
									v-model="datetime.hour"
									:items="hours"
									class="px-1 w100"
									label="時"
									dense
									outlined
								/>
								<v-select
									v-model="datetime.minute"
									:items="minutes"
									class="px-1 w100"
									label="分"
									dense
									outlined
								/>
								<v-select
									v-model="datetime.second"
									:items="seconds"
									class="px-1 w100"
									label="秒"
									dense
									outlined
								/>
							</v-row>
						</template>
						<v-textarea
							v-if="column.reason_required"
							:rules="[rules.required]"
							v-model="reason"
							class="mt-4"
							label="変更理由"
							outlined
							dense
						/>
						<v-row justify="center" class="ma-0">
							<v-btn color="secondary" class="grow" :disabled="!valid" @click="submitForm">
								保存
							</v-btn>
							<v-btn text color="grey" justify-self="end" @click="showForm = false">
								キャンセル
							</v-btn>
						</v-row>
					</v-form>
				</v-list>
			</v-menu>
		</td>
	</v-hover>
</template>

<script>
import moment from "moment/min/moment.min.js"
import axios from "axios"
import _ from "lodash"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import rules from "../../../helper/rules"

import AssociationSelectDialog from "../../shared/AssociationSelectDialog.vue"

export default {
	components: { AssociationSelectDialog },
	props: {
		column: Object,
		item: Object,
		itemValue: null,
	},
	data() {
		return {
			id: this.$route.params.id,
			value: this.itemValue,
			value_target: {},
			valid: false,
			showForm: false,
			rules: rules,
			reason: null,
			datetime: {
				year: null,
				month: null,
				day: null,
				hour: null,
				minute: null,
				second: null,
			},
		}
	},
	mounted() {
		if (this.column.column_type == "datetime") {
			this.datetime.year = Number(moment(this.itemValue).format("YYYY"))
			this.datetime.month = Number(moment(this.itemValue).format("MM"))
			this.datetime.day = Number(moment(this.itemValue).format("DD"))
			this.datetime.hour = Number(moment(this.itemValue).format("HH"))
			this.datetime.minute = Number(moment(this.itemValue).format("mm"))
			this.datetime.second = Number(moment(this.itemValue).format("ss"))
		}
	},
	methods: {
		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/ledgers/models/${this.id}`
			if (this.column.column_type == "datetime") {
				this.value = `${this.datetime.year}-${this.datetime.month}-${this.datetime.day}T${this.datetime.hour}:${this.datetime.minute}:${this.datetime.second}+09:00`
			}
			let params = {
				column_id: this.column.id,
				model_id: this.item.id,
				meta_tag_id: this.column.meta_tag_id,
				model: {},
			}

			if (this.column.meta_tag_id && this.column.meta_association_name) {
				params.model = this.value_target
			} else if (this.column.meta_tag_id) {
				params.model.value = this.value
			} else {
				params.model[this.column.column_name] = this.value
			}
			if (this.column.reason_required) params.model.reason = this.reason

			axios
				.put(url, params, { headers })
				.then((res) => {
					this.showForm = false
					this.reason = null
						this.$emit("change-value", res.data)
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		cellValue(column) {
			if (this.itemValue == null) return null
			if (column.prefix_formula && column.prefix_number) {
				return Function(
					"return (" +
						`${column.prefix_number}${this.formula[column.prefix_formula]}${this.itemValue}` +
						");"
				)()
			} else if (column.suffix_formula && column.suffix_number) {
				return Function(
					"return (" +
						`${this.itemValue}${this.formula[column.suffix_formula]}${column.suffix_number}` +
						");"
				)()
			} else {
				if (column.options.length) {
					const option = column.options.find((o) => o.id == this.itemValue)
					if (option) return option.name
				}
				return this.formatValue(column)
			}
		},
		formatValue(column) {
			switch (column.column_type) {
				case "string":
				case "text":
				case "integer":
				case "float":
					return this.itemValue
				case "time":
					return moment(value).format("HH:mm")
				case "date":
					return moment(this.itemValue).format("YYYY/MM/DD")
				case "datetime":
					return moment(this.itemValue).format("YYYY/MM/DD HH:mm")
				case "boolean":
					if (this.itemValue == true) {
						return "○"
					} else if (this.itemValue == false) {
						return "x"
					}
			}
		},
	},
	computed: {
		years() {
			const thisYear = new Date().getFullYear()
			const endYear = 1900
			const years = [...Array(thisYear - endYear + 1)].map((_, i) => thisYear - i)
			return years
		},
		months() {
			const months = [...Array(12)].map((_, i) => i + 1)
			return months
		},
		days() {
			const days = [...Array(31)].map((_, i) => i + 1)
			return days
		},
		hours() {
			const hours = [...Array(24)].map((_, i) => i)
			return hours
		},
		minutes() {
			const days = [...Array(60)].map((_, i) => i)
			return days
		},
		seconds() {
			const days = [...Array(60)].map((_, i) => i)
			return days
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

p {
	white-space: pre-wrap;
	max-width: 100%;
	max-height: 100px;
	overflow-y: scroll;
}
.editable-cell {
	position: relative;
}
.edit-btn {
	top: 0.5rem;
	right: 0.5rem;
	background-color: white;
}

.w100 {
	width: 100px;
	max-width: 100px;
}
.top-border {
	border-top: 8px solid $sub-color;
}
</style>